import React from 'react';
import classNames from 'classnames';
import { HeaderType, SortDirection } from 'utils/types';
import './styles.scss';

interface Props {
  currentSortedBy: string;
  currentSortDirection: string;
  headers: Array<HeaderType>;
  onSort(newSortedBy: string, newSortDirection: string): void;
}

const TableHeaders: React.FC<Props> = ({
  currentSortedBy,
  currentSortDirection,
  headers,
  onSort
}) => {
  const handleHeaderClick = (sortBy: string) => {
    let newSortDirection;
    if (sortBy === currentSortedBy) {
      newSortDirection =
        currentSortDirection === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC;
    } else {
      newSortDirection = SortDirection.ASC;
    }
    onSort(sortBy, newSortDirection);
  };

  return (
    <thead className="table-headers">
      <tr>
        {headers.map((header: HeaderType, index: React.ReactText) => {
          const sortable = header.sortBy;
          const headerClasses = classNames({
            sortable: sortable,
            asc: header.sortBy === currentSortedBy && currentSortDirection === SortDirection.ASC,
            desc: header.sortBy === currentSortedBy && currentSortDirection === SortDirection.DESC
          });
          return (
            <th
              className={headerClasses}
              key={index}
              onClick={() => sortable && handleHeaderClick(header.sortBy)}
              title={header.label}
            >
              {header.content ? header.content : header.label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeaders;
